import React, {Component} from 'react';
import {Flex, Box, Button, Image} from 'rebass';
import {Input} from 'reakit'
import {Content, DesktopBox, MobileBox, MobileHeader} from "../../components/Base";
import {PageSubTitle, PageTitle} from "../../components/Base/Text";
import UserList from '../../components/UserList'
import {withRouter} from "react-router";
import Loading from '../../components/Base/Loading'
import {FloatingButton} from '../../components/Base/Buttons'
import check from "../../resources/img/icons/Checkbox@1x.png";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {filterStudentsByName} from "../../utils";
import BasicSearch from '../../components/Forms/BasicSearch'

const StyledButton = styled(Button)`
border-radius: 43.881px;
box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
width: 200px;
height: 50px;
overflow: hidden;
`;


class NewRoster extends Component {
	state = {
		title: '',
		selected: [],
		search: ''
	};


	handleSubmit = async () => {
		const {selected, title} = this.state;
		const {profile, isFaculty, firebase, history} = this.props;
		console.log('creating roster');
		if (isFaculty && selected.length > 0 && title !== '') {
			// let newChatRef = firebase.chats().doc();
			let members = [profile.id, ...selected];
			const newRosterChat = await firebase.chats().add({
				creator_uid: profile.id,
				is_group: true,
				name: title,
				members,
				post_time: Math.floor(Date.now() / 1000),
				last_updated: Math.floor(Date.now() / 1000),
				messages: [],
				accepted: {status: 1, updated_at: Math.floor(Date.now() / 1000), members: members}

			});
			// let newChat = await newRosterChat.get()
			console.log(newRosterChat.id);

			// let newRosterRef = firebase.rosters().doc();

			const newRoster = await firebase.rosters().add({
				chat_uid: newRosterChat.id,
				name: title,
				creator_uid: profile.id,
				post_time: Math.floor(Date.now() / 1000),
				students_uid: selected,
				shared_with: []
			});
			console.log(newRoster)
		}
		history.push('/app/search')

	};


	handleSelect = (details) => {
		let {selected} = this.state;
		console.log('selected for roster', details);
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({selected})
		}

	};

	handleInput = (e) => {
		this.setState({title: e.target.value})
	};

	handleSearchChange = (e) => {
		this.setState({search: e.target.value});
	}

	render() {
		const {selected, title, search} = this.state;
		const {loading, students} = this.props;
		let disableButton = true;
		if (title !== '' && selected.length > 0) {
			disableButton = false
		}

		const studentList = filterStudentsByName(students, search)
		return (
			<Box> 
				<MobileHeader paddingLeft={'0px'} paddingRight={'0px'}>
					<Box px={'24px'} pb={'10px'}>
						<PageTitle pt={3} color='metaText'><Input onChange={this.handleInput} marginLeft={0} placeholder='Name your roster...'/></PageTitle>
						<PageSubTitle>{selected.length} Students selected</PageSubTitle>
					</Box>
					<BasicSearch handleInput={this.handleSearchChange} search={search} placeholders={'Search Students'}/>
				</MobileHeader>
				<Content>
					<MobileBox>
						<FloatingButton bg={disableButton ? 'meta' : 'purple'} disabled={disableButton} onClick={this.handleSubmit}><Image src={check}/></FloatingButton>
					</MobileBox>
					<DesktopBox pl={3} pb={3} pt={3}>
						<Flex>
							<Box pl={3} mb={1} pt={2} width={1/2}>
								<StyledButton disabled={disableButton}
											onClick={this.handleSubmit} m={1}
											bg={disableButton ? 'gray': 'purple'}>{'Save'}</StyledButton>
								<Link to={'/app/search'}><StyledButton m={1} bg={'metaText'}>Discard</StyledButton></Link>
							</Box>
							<Box ml={'auto'}/>
							<Box  pt={3} pr={'8px'} width={[ 2/5]}>
								<BasicSearch handleInput={this.handleSearchChange} search={search} placeholders={'Search Students'}/>
							</Box>
						</Flex>
						
					</DesktopBox>
					<DesktopBox>
						<PageTitle pt={3} color='metaText'><Input onChange={this.handleInput}
						                                          placeholder='Name your roster here...'/></PageTitle>

					</DesktopBox>
					{loading ? <Loading/> :
						<UserList students={studentList} handleUserClick={this.handleSelect} selected={selected}/>

					}


				</Content>
			</Box>
		)
	}

}


export default withRouter(NewRoster)
